import React from "react";
import "../../App.css";
import CONTACT_US from "../footer";
import About from "../about";
import Testimonials from "../testimonial";
import ScrollArrow from "../ScrollUp";

function About_Page() {
  return (
    <>
      <About />
      
      <Testimonials />
      <CONTACT_US />
      <ScrollArrow />
    </>
  );
}
export default About_Page;
